import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "./translations";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        try {
            return localStorage.getItem("yn-lang") || "pt";
        } catch {
            return "pt";
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem("yn-lang", lang);
        } catch {
            /* storage indisponível */
        }
        document.documentElement.lang = lang === "en" ? "en" : "pt-BR";
    }, [lang]);

    const value = useMemo(
        () => ({ lang, setLang, t: translations[lang] }),
        [lang],
    );

    return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
